export var detectOS = function (ua) {
    if (ua === void 0) { ua = navigator.userAgent; }
    var ipad = /(iPad).*OS\s([\d_]+)/.test(ua);
    var iphone = !ipad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
    var android = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    var ios = iphone || ipad;
    return { ios: ios, android: android };
};
//# sourceMappingURL=detect-os.js.map